import type { ReactNode } from 'react';

export const symbol_battery_android_frame_question: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-38 0-64-26t-26-64v-300q0-38 26-64t64-26h532q13 0 21.5 8.5T692-690q0 13-8.5 21.5T662-660H130q-13 0-21.5 8.5T100-630v300q0 13 8.5 21.5T130-300h554q13 0 21.5 8.5T714-270q0 13-8.5 21.5T684-240H130Zm30-90q-13 0-21.5-8.5T130-360v-240q0-13 8.5-21.5T160-630h465q13 0 21.5 8.5T655-600v240q0 13-8.5 21.5T625-330H160Zm639-79q-10 0-17-6.5t-7-15.5q0-26 14.5-46.5T822-515q19-17 27.5-31.5T858-576q0-21-16.5-36T802-627q-16 0-30 7t-24 18q-7 8-16.5 12t-18.5 0q-10-4-13-13.5t2-17.5q15-25 41.5-39.5T802-675q45 0 75.5 28t30.5 69q0 23-12 46t-36 45q-13 12-22 23.5T826-434q-2 11-9 18t-18 7Zm-26 113q-11-11-11-26t11-26q11-11 26-11t26 11q11 11 11 26t-11 26q-11 11-26 11t-26-11Z"
		/>
	</svg>
);
